// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"be519316","462":"75a8b80d"}[chunkId] + ".chunk.js";
};